import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Sidebar } from "./Sidebar";
import { TopHeader } from "./TopHeader";
import { ErrorBoundary } from "./ErrorBoundary";
import { Toaster } from "../components/ui/sonner";
import { TooltipProvider } from "../components/ui/tooltip";

const TITLE_BY_PATH = [
  { match: /^\/$/, title: "Overview" },
  { match: /^\/dashboard/, title: "Dashboard" },
  { match: /^\/suppliers\/.+/, title: "Supplier Detail" },
  { match: /^\/suppliers/, title: "Suppliers" },
  { match: /^\/experiences\/.+/, title: "Experience Detail" },
  { match: /^\/experiences/, title: "Experiences" },
  { match: /^\/bookings\/.+/, title: "Booking Detail" },
  { match: /^\/bookings/, title: "Bookings" },
  { match: /^\/customers\/.+/, title: "Customer Detail" },
  { match: /^\/customers/, title: "Customers" },
  { match: /^\/support\/.+/, title: "Support Case" },
  { match: /^\/support/, title: "Support Cases" },
  { match: /^\/payments/, title: "Payments & Payouts" },
  { match: /^\/quality/, title: "Quality" },
  { match: /^\/admins/, title: "Admin Users" },
];

function titleFor(pathname) {
  const found = TITLE_BY_PATH.find((t) => t.match.test(pathname));
  return found ? found.title : "Humrahe";
}

export function Layout() {
  const { user, logout } = useAuth();
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  return (
    <TooltipProvider delayDuration={150}>
      <div className="min-h-screen flex bg-background" data-testid="app-layout">
        <Sidebar user={user} collapsed={collapsed} onToggleCollapsed={() => setCollapsed((v) => !v)} />
        <div className="flex-1 flex flex-col min-w-0">
          <TopHeader user={user} onLogout={logout} pageTitle={titleFor(location.pathname)} />
          <main className="flex-1 overflow-x-hidden">
            <div className="max-w-[1500px] mx-auto px-4 lg:px-6 pb-12">
              <ErrorBoundary key={location.pathname}>
                <Outlet />
              </ErrorBoundary>
            </div>
          </main>
        </div>
        <Toaster position="top-right" richColors closeButton />
      </div>
    </TooltipProvider>
  );
}
